module.exports = {
  emptyMessage: 'يُرجى كتابة الاسم كما يظهر على البطاقة.',
  containsNumberMessage: 'يُرجى كتابة الاسم كما يظهر على البطاقة.',
  maxLengthMessage: 'عفواً! لقد تجاوزت عدد الأحرف المسموح به، يُرجى إعادة تعبئته.',
  defaultMessage: 'عفواً! هذا اسم غير صالح.',
};
